export const undoableReducer = (reducer, options)=>{
    // Call the reducer with empty action to populate the initial state
    const initialState = {
        past: [],
        present: reducer(undefined, {
            type: '__INIT_UNDOABLE__'
        }),
        future: []
    };
    // Return a reducer that handles undo and redo
    return (state = initialState, action)=>{
        const { past, present, future } = state;
        const actionAny = action;
        if (!options.actionTypes || options.actionTypes.indexOf(actionAny.type) !== -1) {
            const newPresent = reducer(present, actionAny);
            if (newPresent !== present) {
                const addHistoryEntry = !(actionAny.options || {}).skipHistory;
                const newPast = addHistoryEntry ? [
                    ...past,
                    present
                ] : past;
                return {
                    past: newPast,
                    present: newPresent,
                    future: []
                };
            }
        }
        if (options.undoType && actionAny.type === options.undoType) {
            if (!past.length) {
                return state;
            }
            const previous = past[past.length - 1];
            const newPast = past.slice(0, past.length - 1);
            return {
                past: newPast,
                present: previous,
                future: [
                    present,
                    ...future
                ]
            };
        } else if (options.redoType && actionAny.type === options.redoType) {
            if (!future.length) {
                return state;
            }
            const next = future[0];
            const newFuture = future.slice(1);
            return {
                past: [
                    ...past,
                    present
                ],
                present: next,
                future: newFuture
            };
        } else if (options.undoAllType && actionAny.type === options.undoAllType) {
            if (!past.length) {
                return state;
            }
            const first = past[0];
            const newFuture = past.slice(1);
            return {
                past: [],
                present: first,
                future: [
                    ...newFuture,
                    ...future
                ]
            };
        }
        return state;
    };
};
